import { reactive } from 'vue'
import { defineStore } from 'pinia'
import { RequestCodeEnum } from '@/enums/requestEnums'
import { custom_app_get_cache_item } from '@/service/generate/t_user_custom_app_generate_data'

export const useChannelAppStore = defineStore('channelAppStore', () => {
    const channelApp = reactive<any>({})
    const setChannelApp = data => {
        Object.assign(channelApp, data)
    }

    const onload = async prefix => {
        const res = await custom_app_get_cache_item({
            data: { app_namespace_prefix: prefix },
            config: { isCache: true }
        })
        if (res.code === RequestCodeEnum.OK) {
            setChannelApp(res?.data ?? {})
            if (res?.data?.app_name) {
                document.title = res?.data?.app_name
            }
        }
    }

    return { channelApp, setChannelApp, onload }
})
